// extracted by mini-css-extract-plugin
module.exports = {"row-wrapper":"_3hQgEtUcFaHa8424v4uklX","text-title":"_1bIu7sBKKtg4zSGZo01xTD","text-number":"_1QWNRRlbA5sKspO8Cgnj5E"};